<mat-form-field appearance="legacy">
    <mat-label>{{nombreCampo}}</mat-label>
    <mat-select multiple [(ngModel)]="value" (selectionChange)="selectChange()">
        <mat-option value="">TODOS</mat-option>
        <mat-option *ngFor="let row of opciones" [value]="row.id">{{row.descripcion}}</mat-option>
    </mat-select>
</mat-form-field>